// extracted by mini-css-extract-plugin
export default {"forgot":"style_forgot__aFU+5","btnHolder":"style_btnHolder__YIEwk"};